<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-08-18 15:03:05
 * @Description: 
-->
<template>
  <div
    class="abs_lt fs12 lhm p2 omit tl maxw cp"
    :class="[info?.current_customer_statistics?.count === 1 ? 'bgy' : 'bgto']"
    :style="{ borderRadius: '0 0 4px 0', zIndex: zIndex }"
    :title="infoText"
  >
    {{ infoText }}
  </div>
</template>

<script>
  // 基础产品编码组件
  import { defineComponent, reactive, toRefs, computed } from 'vue'
  import { t } from '@/utils/i18n'

  export default defineComponent({
    name: 'BaseLastSellInfo',
    components: {},
    props: {
      info: { type: Object, default: () => {} },
      tips: { type: String, default: '' },
      zIndex: { type: Number, default: 1 },
    },
    setup(props) {
      const state = reactive({})
      const infoText = computed(() => {
        if (props.tips) return props.tips
        const productInfo = props.info?.product_info || props.info || {}
        const current_customer_statistics =
          props.info.current_customer_statistics
        const result =
          current_customer_statistics?.count === 1
            ? t('首次采购')
            : `${t('第')} ${current_customer_statistics?.count || ''} ${t(
                '次采购,之前共采购'
              )} ${current_customer_statistics?.total || ''} ${
                productInfo.unit || ''
              }`
        return result
      })
      return {
        infoText,
        ...toRefs(state),
        t,
      }
    },
  })
</script>

<style lang="scss" scoped></style>
